'use strict';

var _ = require('lodash');
var FlightDropdownValuesService = function FlightDropdownValuesService(hepService, dropdownValuesService, configurationService) {
  /**
   * Flattened HEP list
   * @type {Array}
   */
  var values = [];

  /**
   * Transform HEP list data to flat array of objects
   *
   * @param {Object} data
   */
  function transformData(data) {
    var localOrSignificantMarkets = configurationService.getNonCodeShareMarkets();
    var airlines = configurationService.getHostAndSubsidiaryCarriers();
    _.transform(data.hepList, function (result, item) {
      if (dropdownValuesService.isLocalOrSignificantMarket(localOrSignificantMarkets, item.attributes)) {
        var affectedCarriers = _.isNil(item.attributes.carrier) ? airlines : [item.attributes.carrier];
        _.forEach(affectedCarriers, function (carrier) {
          result.push({
            airline: carrier,
            flightEntity: item.properties.entityName,
            flightLeg: item.attributes.origin + '-' + item.attributes.destination,
            flightNumber: item.attributes.number
          });
        });
      }
      return result;
    }, values);
  }

  /**
   * Returns array of dropdown values
   *
   * @param {string} column
   * @param {Object} row
   * @returns {string[]}
   */
  function getDropdownValues(column, row) {
    var columnsSortingFunctions = {
      'flightNumber': _.toNumber
    };
    return dropdownValuesService.getValues(values, column, row, columnsSortingFunctions);
  }
  function updateData() {
    values = [];
    hepService.getHepByType('FlightEntity').then(transformData);
  }
  return {
    getDropdownValues: getDropdownValues,
    updateData: updateData
  };
};
FlightDropdownValuesService.$inject = ['HepService', 'DropdownValuesService', 'ConfigurationService'];
module.exports = FlightDropdownValuesService;